import { WCG_TOAST_CONFIG } from '@erm/cluster';
import {
  REMEDIATION_RUN_ACTION_TYPE,
  RemediationRunActionPayload,
  RemediationRunState,
} from '../types/remediation-run.types';

export const REMEDIATION_RUN_ACTION_LABEL_MAP = new Map<string, string>([
  ['Dry run', 'dry-run'],
  ['Run', 'run'],
  ['Approve', 'approve'],
  ['Withdraw', 'withdraw'],
  ['Reject', 'reject'],
]);

export type RemediationRunDecisionActionType = Extract<
  REMEDIATION_RUN_ACTION_TYPE,
  'approve' | 'withdraw' | 'reject'
>;

export const REMEDIATION_RUN_DECISION_ACTION_PAYLOAD_MAP: Record<
  RemediationRunDecisionActionType,
  RemediationRunActionPayload
> = {
  approve: {
    status: 'Approved',
  },
  withdraw: {
    status: 'Withdrawn',
  },
  reject: {
    status: 'Rejected',
  },
};

export const REMEDIATION_RUN_INITIAL_STATE: RemediationRunState = {
  total: 0,
  page: 1,
  pageSize: 25,
  searchTerm: '',
  status: 'All',
  statusFilters: [],
  isLoading: false,
  error: null,
  isSubmitting: false,
  dryRunStatus: null,
  isDryRunning: false,
  dryRunStatusCode: null,
  dryRunErrorBody: null,
  isLoadingDryRunStatus: false,
  executePreview: null,
  executeResult: null,
  isPreviewing: false,
  isExecuting: false,
  executeStatusCode: null,
  executeErrorBody: null,
};

export const REMEDIATION_RUN_DRY_RUN_FAILED_MESSAGE =
  'This run failed and no data was changed. Please try again or contact L2 for help.';

export const REMEDIATION_ACCESS_DENIED_TOAST_CONFIG = {
  ...WCG_TOAST_CONFIG,
  data: {
    message:
      "You don't have access to the Admin Tool. If you need access, contact your Support Admin.",
  },
  duration: 5000,
  toastType: 'error' as const,
  horizontalPosition: 'center' as const,
};
